import script from "./StatCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./StatCounter.vue?vue&type=script&setup=true&lang=js"

import "./StatCounter.vue?vue&type=style&index=0&id=52f0f3ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f0f3ba"]])

export default __exports__